import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, Leaf } from "lucide-react";
import frDict from "@/locales/fr.json";

export default function ThankYou() {
  const t = (path) =>
    path.split(".").reduce((a, k) => (a ? a[k] : undefined), frDict) || path;

  useEffect(() => {
    document.title = `${t("thank_you.title")} — ${t("brand.name")}`;
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-20 max-w-7xl items-center px-4 sm:px-6 lg:px-10">
          <Link to="/" className="flex items-center gap-3" data-testid="thank-you-brand-link">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-emerald-600 text-white">
              <Leaf className="h-6 w-6" strokeWidth={2.25} />
            </span>
            <span className="font-heading text-[15px] font-bold tracking-tight text-slate-900">
              {t("brand.name")}
            </span>
          </Link>
        </div>
      </header>

      <main className="flex flex-1 items-center">
        <div className="mx-auto w-full max-w-2xl px-4 py-24 text-center sm:px-6 lg:px-10">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100">
            <CheckCircle2 className="h-9 w-9 text-emerald-700" />
          </div>
          <p className="mt-6 text-xs font-semibold uppercase tracking-widest text-emerald-700">
            {t("thank_you.eyebrow")}
          </p>
          <h1
            data-testid="thank-you-title"
            className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl"
          >
            {t("thank_you.title")}
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-700">
            {t("thank_you.body")}
          </p>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate-500">
            {t("thank_you.note")}
          </p>

          <Link
            to="/"
            data-testid="thank-you-back-home-button"
            className="mt-10 inline-flex items-center gap-2 rounded-md bg-slate-900 px-6 py-3.5 text-sm font-semibold text-white hover:bg-slate-800"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("thank_you.back_home")}
          </Link>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-6 text-xs text-slate-500 sm:px-6 lg:px-10">
          {t("footer.copyright")}
        </div>
      </footer>
    </div>
  );
}
